export const BASE_PATH = process.env.PUBLIC_URL || '';
export const IMAGE_PATH = `${BASE_PATH}/images`;